// this.$store.state.privilegios

// Clase de privilegios
// Se obtiene usando new this.$store.state.privilegios(booleano).obtener()
export const privilegios = class {
  // La variable "valor" debe ser un booleano
  constructor(valor = false) {
    // Se condiciona para aceptar solo valores booleanos
    // En caso de no ser un valor booleano
    // Se tomara por defecto como false
    valor = typeof valor === "boolean" ? valor : false;
    // Objetos de privilegios
    this.empresa = {
      ver: valor,
      editar: valor,
      horarios: {
        ver: valor,
        crear: valor,
        editar: valor,
        eliminar: valor,
      },
      vinculaciones: {
        ver: valor,
        crear: valor,
        editar: valor,
        vincular: valor,
        desvincular: valor,
      },
      regionales: {
        ver: valor,
        crear: valor,
        editar: valor,
        eliminar: valor,
      },
      profesiogramas: {
        ver: valor,
        crear: valor,
        editar: valor,
        eliminar: valor,
      },
    };
    this.controlPersonal = {
      ver: valor,
      controlDiario: valor,
      registroManual: valor,
      registrarQR: valor,
      estadisticas: valor,
      ausentismo: valor,
    };
    this.capacitaciones = {
      ver: valor,
      crear: valor,
      editar: valor,
      eliminar: valor,
      evaluar: valor,
      estadisticas: valor,
    };
    this.seguridadVial = {
      ver: valor,
      infografias: {
        ver: valor,
        crear: valor,
        editar: valor,
        eliminar: valor,
      },
      conductores: {
        ver: valor,
        crear: valor,
        editar: valor,
        eliminar: valor,
      },
      vehiculos: {
        ver: valor,
        crear: valor,
        editar: valor,
        eliminar: valor,
      },
      formatos: {
        ver: valor,
        crear: valor,
        editar: valor,
        eliminar: valor,
      },
      inspecciones: {
        ver: valor,
        crear: valor,
        editar: valor,
        eliminar: valor,
      },
      mantenimientos: {
        ver: valor,
        crear: valor,
        editar: valor,
        eliminar: valor,
      },
      siniestralidadVial: {
        ver: valor,
        crear: valor,
        editar: valor,
        eliminar: valor,
      },
      // Informe Anual de Autogestión del PESV (issue #1187, RF-02)
      informeAutogestion: {
        ver: valor,
        generar: valor,
      },
    };
    this.panelAdministrativo = {
      ver: valor,
    };
  }
  definir() {
    return {
      empresa: this.empresa,
      controlPersonal: this.controlPersonal,
      capacitaciones: this.capacitaciones,
      seguridadVial: this.seguridadVial,
      panelAdministrativo: this.panelAdministrativo,
    };
  }
};
